import { IInventoryPage } from '../../../inventory-page.interface';


export const UPLOAD_POD_TM_BLACKLIST_PAGE: IInventoryPage = {
	'route': '/upload/pod/tm-blacklist',
	'title': 'TM Blacklist',
	'uiReference': [
		'Blacklist tools',
		'Enter a term to block',
		'Add an optional note',
		'Blacklist entry',
		'Block a trademark term',
		'Add words that should trigger warnings or be blocked during listing checks.',
		'Community blacklist',
		'Import',
		'Export',
		'Word or phrase',
		'Language',
		'Note',
		'Add to blacklist',
		'The spreadsheet import supports the following formats: .csv, .xls, .xlsx, .odt. The format of the excel sheet has to be as the example shown below. Please pay special attention to the column naming. The columns can be rearranged and will be detected in any order.',
		'Filter saved terms',
		'Filter personal notes',
		'Loading saved terms...',
		'Saved terms',
		'entries',
		'Delete all',
		'Filter results',
		'Refine entries',
		'Filter options',
		'Reset filters',
		'No records found',
		'Adjust the filters to see more saved terms.'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/pod-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/tm-blacklist/tm-blacklist.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/tm-blacklist/tm-blacklist.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/shared/tm-list/tm-list.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/shared/tm-list/tm-list.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/shared/tm-list/tm-list.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.html'
	],
	'aliases': []
};
